import React from "react";
import { Spin } from "antd";

/**
 * Fallback shown while a lazy route chunk loads.
 */
export default function RouteFallback() {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        width: "100%",
      }}
    >
      <Spin size="large" />
    </div>
  );
}
